import {ControlApi} from '../api/ControlApi';
import {BaseValidatedClass} from '../BaseValidatedClass';
import {ImmutableHtmlNode} from '../modifications/ImmutableNode';

export class Control extends BaseValidatedClass {
    /** Provides access to editor functionalities specific to this UI control instance. */
  public api!: ControlApi;

  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS = ['getId', 'getTemplate'];

  constructor() {
    super(Control.REQUIRED_METHODS, Control);
  }

  /**
   * @description Allows to determine if control should be visible or hidden in control panel.
   * Called on every node modification.
   */
  public isVisible(_node: ImmutableHtmlNode): boolean {
    return true;
  }

    /**
     * Optional hook called when the control is initially rendered.
     * Use this for setup tasks like attaching event listeners to the control's template elements.
     */
  public onRender(): void {}
    /**
     * Optional cleanup hook called when the control is being destroyed.
     * Use this to remove event listeners or perform other cleanup tasks.
     */
  public onDestroy(): void {}

    /**
     * Gets the unique identifier for this UI control type.
     * This ID is used for registration and referencing.
     * @returns A unique string ID.
     */
  public getId(): string {
    throw new Error('Method getId() must be implemented by the subclass');
  }

    /**
     * Gets the HTML template string that defines the structure of this UI control,
     * typically containing one or more UI elements (e.g., `<UE-TEXT>`, `<UE-BUTTON>`).
     * @returns An HTML string.
     */
  public getTemplate(): string {
    throw new Error('Method getTemplate() must be implemented by the subclass');
  }

    /**
     * Hook called whenever the underlying template node associated with this control's context
     * (e.g., the selected block's  HTMLnode) is updated.
     * Implement this to react to changes in the block/structure and update the control's UI elements accordingly.
     * @param node - The updated immutable HTML node representing the control's context.
     */
  public onTemplateNodeUpdated(_node: ImmutableHtmlNode): void {
  }

  /**
   * Lifecycle hook called when any part of the document template has changed.
   * This can be frequent; use cautiously for performance-sensitive operations.
   * @param _node - The immutable HTML node representing current node instance
   */
  public onDocumentChanged(_node: ImmutableHtmlNode): void {}
}
